/**
 * DUNAMIS WEAR — Theme JavaScript
 * Entry point and global utilities
 */

(function () {
  'use strict';

  const theme = window.theme || {};

  /**
   * Publish custom events
   */
  theme.publish = function (eventName, data) {
    document.dispatchEvent(new CustomEvent(eventName, { detail: data, bubbles: true }));
  };

  /**
   * Subscribe to custom events
   */
  theme.subscribe = function (eventName, callback) {
    document.addEventListener(eventName, callback);
    return function () {
      document.removeEventListener(eventName, callback);
    };
  };

  /**
   * Fetch helper with JSON
   */
  theme.fetchJSON = function (url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    });
  };

  /**
   * Format money (BRL)
   */
  theme.formatMoney = function (cents) {
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: theme.settings.currency || 'BRL'
    });
  };

  /**
   * Debounce utility
   */
  theme.debounce = function (fn, delay) {
    let timer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  };

  /**
   * Trap focus within element
   */
  theme.trapFocus = function (container) {
    const focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function handleKeydown(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    container.addEventListener('keydown', handleKeydown);
    first && first.focus();

    return function () {
      container.removeEventListener('keydown', handleKeydown);
    };
  };

  /**
   * Compat: stubs de viewport (zoom livre; sem lock).
   */
  theme.mobileViewport = {
    lock: function () {},
    unlock: function () {},
    reset: function () {}
  };

  /**
   * Carrega imagem de hover/costa só no primeiro pointer/touch.
   */
  function hydrateDeferredImage(img) {
    if (!img || img.dataset.deferReady === '1') return;
    var src = img.getAttribute('data-defer-src');
    var srcset = img.getAttribute('data-defer-srcset');
    if (!src && !srcset) return;
    img.dataset.deferReady = '1';
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
    img.removeAttribute('data-defer-src');
    img.removeAttribute('data-defer-srcset');
  }

  function bindDeferredHovers(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-defer-src]').forEach(function (img) {
      if (img.dataset.deferBound === '1') return;
      img.dataset.deferBound = '1';
      var host =
        img.closest('[data-catalog-flip], .product-card, .catalog-card') || img.parentElement;
      if (!host) return;
      var hydrate = function () {
        hydrateDeferredImage(img);
      };
      host.addEventListener('pointerenter', hydrate, { once: true, passive: true });
      host.addEventListener('touchstart', hydrate, { once: true, passive: true });
      host.addEventListener('focusin', hydrate, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindDeferredHovers();
    });
  } else {
    bindDeferredHovers();
  }
  document.addEventListener('shopify:section:load', function (e) {
    bindDeferredHovers(e.target);
  });

  window.theme = theme;
})();
